export default "__VITE_ASSET__Bzv4HakU__"